import { SweetAlertOptions } from "sweetalert2";
import { CustomToast, ErrorToast, SuccessToast, InfoToast } from "../common/toasts/toasts";

type ToastType = "info" | "success" | "error";

export const showToast = (type: ToastType, options: SweetAlertOptions) => {
	switch (type) {
		case "info":
			InfoToast.fire(options);
			break;
		case "error":
			ErrorToast.fire(options);
			break;
		case "success":
			SuccessToast.fire(options);
			break;
		default:
			CustomToast.fire({ ...options });
			break;
	}
};
